interface PrintLabelHeaderProps {
  title?: string;
  deliveryDate: string;
  deliveryCity: string;
  owner: string;
}

const hrStyle = {
  border: 'none' as const,
  backgroundColor: 'black',
  height: '2px',
  width: '50%',
  margin: '10px auto 15px auto',
};

export function PrintLabelHeader({ title, deliveryDate, deliveryCity, owner }: PrintLabelHeaderProps) {
  return (
    <>
      {title && (
        <>
          <p style={{ fontSize: '15px', lineHeight: '15px', margin: '0' }}>{title}</p>
          <hr style={hrStyle} />
        </>
      )}
      <p style={{ fontSize: '15px', lineHeight: '15px', margin: '0 0 10px 0' }}>{deliveryDate}</p>
      <p style={{ fontSize: '15px', lineHeight: '15px', margin: '0' }}>{deliveryCity}</p>
      <hr style={hrStyle} />
      <p style={{ fontSize: '16px', lineHeight: '16px', margin: '0' }}>
        <b>{owner}</b>
      </p>
      <hr style={{ ...hrStyle, margin: '10px auto 25px auto' }} />
    </>
  );
}
